"use strict";


angular.module('app.controllers.device.heatingCurve', []).config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('device.heatingcurve', {
            parent: 'device',
            url: '/heatingcurve/:heatingCurve',
            templateUrl: 'views/device.heatingcurve.html',
            params: {configData: null},
            defaultParams: {heatingCurve: '1'},
            controller: 'HeatingcurveCtrl',
            resolve: {
                heatingCurveDatapoint : function(conf_wellKnownObjects,$stateParams){
                    'ngInject';

                    return conf_wellKnownObjects['HeatingCurve'+$stateParams.heatingCurve];
                }

            },
            breadcrumb: {
                name: function () {
                    return 'NAV_HeatingCurve';
                }
            }
        })
        $stateProvider.state('device.heatingcurve.edit', {
            parent: 'device.heatingcurve',
            url: '/edit'


        })
    }])
    .controller("HeatingcurveCtrl", [
        '$rootScope', '$scope', '$filter', 'heatingCurveDatapoint','actualDevice','__DatapointValue','f_User',
        '__MenuEntry','viewMenuBarService','$stateParams','__DatapointConfig','heatingCurvePresetModal','$translate',
        function ($rootScope, $scope, $filter,  heatingCurveDatapoint,actualDevice,__DatapointValue,f_User,
            __MenuEntry,viewMenuBarService,$stateParams,__DatapointConfig, heatingCurvePresetModal, $translate) {


            // Todo: To be updated by global Timeout
            $scope.datum = new Date();
            $scope.rootScope = $rootScope;

            // Get Breadcrumb on first load
            //$scope.breadcrumb = MasterService.getBreadcrumb();

            function getMenuEntryId(stateParams) {
                if (stateParams.menuEntry && stateParams.menuEntry.MenuEntryId) {
                    return stateParams.menuEntry.MenuEntryId;
                }
                if ($stateParams.configData && $stateParams.configData.EntryId) {
                    return $stateParams.configData.EntryId;
                }
                return null;
            }

            var favoriteObject =
            {
                favoriteType : 'MenuEntry',
                favoriteObject:
                    __MenuEntry.$buildRaw({
                        "$type" : "BMS.Shared.Model.System.FavoriteCustomAction, BMS.Shared",
                        "MenuEntryId": getMenuEntryId($stateParams),
                        "MenuEntryType": 3, // For Toggle Favorite to check MenuEntryType.
                        "DeviceId": actualDevice.DeviceId,
                        'CustomActionName': 'HeatingCurve'+$stateParams.heatingCurve,
                        'DisplayName': $translate.instant('NAV_HeatingCurve'),
                        'ImageName': 'statistik',

                        $UI:{}
                    })
            };
            viewMenuBarService.setFavorite(favoriteObject);

            $scope.init = function () {
                $rootScope.backbutton = true;
                $scope.yAxis = [];
                for (var i = 65; i >= 5; i = i - 5) {
                    $scope.yAxis.push(i);
                }
                var a = [{'DatapointConfigId':heatingCurveDatapoint,DeviceId:actualDevice.DeviceId}];

                $scope.curve = __DatapointValue.$collection(a).$refresh().$then(function(data){

                    var r =$scope.curve[0];

                    if (r.Value && r.Value.CurveValues) {
                        r.Value.CurveValues = $filter('orderBy')(r.Value.CurveValues, '-XValue');
                    }
                    $scope.curve = r;
                    $scope.curve.desc = {
                        xVal: {
                            type: 'temperature',
                            text: 'HEATINGCURVE_Aussen'
                        },
                        yVal: {
                            type: 'temperature',
                            text: 'HEATINGCURVE_Vorlauf'
                        }
                    };

                });
                __DatapointConfig
                .$ByDeviceId(
                    {
                        DeviceId: actualDevice.DeviceId,
                        DatapointConfigIds:[heatingCurveDatapoint]
                    }
                )
                .$then(function(data){
                    var dp = data[0];
                    $scope.userCanEdit = (f_User.getUserLevel() >= dp.UserLevelWrite ? true : false);
                });



                //var o = MasterService.getLastPathItem();

                //$rootScope.favoritebutton = true;
                /*if (o && o.object) {
                 $rootScope.favoriteObject = o.object;
                 o.object.isFaved = false;
                 $rootScope.favoriteFunction = function (ob) {
                 MasterService.toggleFavorite(ob);
                 };
                 };*/

            }


            $scope.editCurve = function () {
                $scope.tempCurve = angular.copy($scope.curve);
                $scope.curve.$UI.editMode = true;
            }
            $scope.saveCurve = function (c) {
                delete c.$UI.editMode;
                $scope.curve.$save();
              /*  var dp = new Datapoint($http);
                dp.fillWithDataAndSave(c, function (data) {
                    var r = dp.parseResponse(data);

                })*/

            }
            $scope.revertCurve = function (c) {
                $scope.curve.Value  = angular.copy($scope.tempCurve.Value);
                $scope.curve.Value.CurveValues  = angular.copy($scope.tempCurve.Value.CurveValues);
            }

            function calcTemperatur(parameter, außentemperatur)
            {
                let vorlaufTemp = (parameter.AnfangspunktHeizkurve + (parameter.EndpunktHeizkurve - parameter.AnfangspunktHeizkurve) * Math.exp((1 / parameter.TemperatureexponentHeizanlage) * Math.log((außentemperatur - parameter.AußentempAnfangspunktHeizkurve) / (parameter.AußentempEndpunktHeizkurve - parameter.AußentempAnfangspunktHeizkurve))));

                return vorlaufTemp;
            }

            $scope.getHeizkurve = function() {
                heatingCurvePresetModal($scope.curve.Value.Info).then(function (modal) {
                modal.close.then(function (data) {
                    if (data) {
                        $scope.editCurve();

                        let params = {};

                        params[ 1] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 30.0, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 2] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 31.6, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 3] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 33.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 4] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 34.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 5] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 36.5, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 6] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 38.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 7] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 40.0, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 8] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 41.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[ 9] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 43.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[10] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 45.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[11] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 47.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[12] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 50.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[13] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 52.5, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[14] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 55.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[15] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 57.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[16] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 60.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[17] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 64.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[18] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 67.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[19] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 71.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[20] = { AnfangspunktHeizkurve: 25.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 76.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.30 };
                        params[21] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 30.0, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[22] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 31.6, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[23] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 33.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[24] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 34.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[25] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 36.5, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[26] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 38.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[27] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 40.0, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[28] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 41.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[29] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 43.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[30] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 45.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[31] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 47.9, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[32] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 50.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[33] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 52.5, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[34] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 55.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[35] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 57.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[36] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 60.8, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[37] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 64.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[38] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 67.7, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[39] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 71.1, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };
                        params[40] = { AnfangspunktHeizkurve: 23.0, AußentempAnfangspunktHeizkurve: 20.0, EndpunktHeizkurve: 76.2, AußentempEndpunktHeizkurve: -15.0, TemperatureexponentHeizanlage: 1.10 };

                        let chosenPreset = params[data];
                        let newCurve = [];

                        for (let i = -20; i <= 20; i = i + 5)
                        {
                            let val = calcTemperatur(chosenPreset, i);
                            if (val > 65) val = 65;
                            if (val < 0) val = 0;
                            newCurve.push({ 'XValue': i, 'YValue': val });
                        }

                        $scope.curve.Value.Info = data;
                        $scope.curve.Value.CurveValues = newCurve;
                    }

                });


            });
            }

            $scope.$on('UserlevelChange', function () {
                $scope.init();
            })

            $scope.init();

        }]);
